export default __webpack_public_path__ + "static/media/EmptyWish.120a9535.png";